// import GigplaceList from "../components/admin/Gigplace/Index.vue"; // gigplace disabled
// import GigplaceEdit from "../components/admin/Gigplace/Edit.vue";
// import AdminDashboard from "../components/admin/Dashboard.vue";
// import AdminDPJobsList from "../components/admin/AdminDPJobs.vue";


// import JobseekerAppliedJobList from '../components/admin/jobseeker/appliedJobs.vue'
// import FlGigEdit from "../components/admin/Jobseeker/Gig/Edit.vue";

export default [
  {
    path: "/v2/admin/dashboard",
    name: "admin-dashboard-list",
    route: "admin-dashboard-list",
    component: () => import('../components/admin/AdminDashboard.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  // {
  //   path: "/v2/admin/dp-jobs",
  //   name: "admin-dp-jobs-list",
  //   route: "admin-dp-jobs-list",
  //   component: AdminDPJobsList,
  //   meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  // },
  {
    path: "/v2/admin/v1-dp-jobs",
    name: "admin-v1-dp-jobs",
    route: "admin-v1-dp-jobs",
    component: () => import('../components/admin/AdminV1DPJobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/reviews-and-ratings/freelancer-rating",
    name: "freelancer-rating-view",
    route: "freelancer-rating-view",
    component: () => import('../components/admin/ReviewAndRating/FreelancerRating.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/reviews-and-ratings/employer-rating",
    name: "employer-rating-view",
    route: "employer-rating-view",
    component: () => import('../components/admin/ReviewAndRating/EmployerRating.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/Marketing/telegram-jobs",
    name: "telegram-jobs",
    route: "telegram-jobs",
    component: () => import('../components/admin/TelegramJobs/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/Marketing/whatsapp-channel-jobs",
    name: "whatsapp-channel-jobs",
    route: "whatsapp-channel-jobs",
    component: () => import('../components/admin/WhatsappChannelJobs/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/payout/demo-payout",
    name: "demo-payout",
    route: "demo-payout",
    component: () => import('../components/admin/TelegramJobs/DemoPayout.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/jobseeker/dashboard",
    name: "jobseeker-dashboard",
    route: "jobseeker-dashboard",
    component: () => import('../components/Dashboard.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/employer/dashboard-demo",
    name: "employee-dashboard",
    route: "employee-dashboard",
    component: () => import('../components/Dashboard.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/jobseeker/jobseeker-profile",
    name: "jobseeker-profile",
    route: "jobseeker-profile",
    component: () => import('../components/admin/jobseeker/JobseekerProfile.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/admin/database/jobseeker-transaction/:id",
    name: "jobseeker-transaction-view",
    route: "jobseeker-transaction-view",
    component: () => import('../components/admin/JobseekerAdmin/transaction.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/database/jobseeker-payslip/:id",
    name: "jobseeker-payslip-view",
    route: "jobseeker-payslip-view",
    component: () => import('../components/admin/JobseekerAdmin/payslip.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/database/jobseeker-referred-fl/:id",
    name: "jobseeker-referred-fl",
    route: "jobseeker-referred-fl",
    component: () => import('../components/admin/JobseekerAdmin/ReferredFreelancer.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/database/jobseeker-profile/view/:id",
    name: "jobseeker-profile-view",
    route: "jobseeker-profile-view",
    component: () => import('../components/admin/JobseekerAdmin/JobseekerProfileView.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/jobseeker/insurance-claim/submit/:id",
    name: "jobseeker-insurance-claim-submit",
    route: "jobseeker-insurance-claim-submit",
    component: () => import('../components/admin/JobseekerAdmin/InsuranceClaim/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/jobseeker/jobseeker-certificate/manage/:id",
    name: "jobseeker-certificate-manage",
    route: "jobseeker-certificate-manage",
    component: () => import('../components/admin/JobseekerAdmin/Certificate/manageCertificate.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/jobseeker/jobseeker-certificate/add/:id/:cert_id",
    name: "jobseeker-certificate-add",
    route: "jobseeker-certificate-add",
    component: () => import('../components/admin/JobseekerAdmin/Certificate/addCertificate.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/jobseeker/jobseeker-certificate/edit/:id/:cert_id/:edit_id",
    name: "jobseeker-certificate-edit",
    route: "jobseeker-certificate-edit",
    component: () => import('../components/admin/JobseekerAdmin/Certificate/editCertificate.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/jobseeker/jobseeker-badge/manage/:fl_id",
    name: "jobseeker-badge-manage",
    route: "jobseeker-badge-manage",
    component: () => import('../components/admin/JobseekerAdmin/Badge/manageBadge.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/deployment/daily-deployment",
    name: "daily-deployment-list",
    route: "daily-deployment-list",
    component: () => import('../components/admin/DailyDeployment/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/deployment/staff-deployment",
    name: "staff-deployment-list",
    route: "staff-deployment-list",
    component: () => import('../components/admin/StaffDeployment/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/deployment/company-posting",
    name: "company-posting-list",
    route: "company-posting-list",
    component: () => import('../components/admin/CompanyPosting/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/deployment/daily-statistics",
    name: "daily-statistics",
    route: "daily-statistics",
    component: () => import('../components/admin/Deployment/DailyStatistics.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/deployment/cancellation-report",
    name: "cancellation-report",
    route: "cancellation-report",
    component: () => import('../components/admin/Deployment/CancellationReport.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/heatmap",
    name: "heat-map-list",
    route: "heat-map-list",
    component: () => import('../components/admin/HeatMap/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/daily-signup-approved",
    name: "daily-signup-approved",
    route: "daily-signup-approved",
    component: () => import('../components/admin/SignUp/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    // Drill-down from the dashboard's Revenue Summary widget. Deliberately not
    // in the sidebar — same convention as daily-signup-approved / view-counts.
    path: "/v2/admin/revenue-summary",
    name: "revenue-summary",
    route: "revenue-summary",
    component: () => import('../components/admin/RevenueSummary/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/certs",
    name: "certs-list",
    route: "certs-list",
    component: () => import('../components/admin/Table/Certs/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/food-hygiene-cert",
    name: "food-hygiene-cert-list",
    route: "food-hygiene-cert-list",
    component: () => import('../components/admin/Table/FoodHygieneCert/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/survey-results",
    name: "survey-results",
    route: "survey-results",
    component: () => import('../components/admin/Table/SurveyResults/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/view-counts",
    name: "view-counts",
    route: "view-counts",
    component: () => import('../components/admin/Table/ViewCounts/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/company-whitelists",
    name: "company-whitelists",
    route: "company-whitelists",
    component: () => import('../components/admin/Table/CompanyWhitelist/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/opt-out-whatsapp-blast",
    name: "opt-out-whatsapp-blast",
    route: "opt-out-whatsapp-blast",
    component: () => import('../components/admin/Table/OptOutWhatsappBlast/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/company-fulfilment-rate",
    name: "company-fulfilment-rate",
    route: "company-fulfilment-rate",
    component: () => import('../components/admin/Table/CompanyFulfilmentRate/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/user-badges",
    name: "user-badges",
    route: "user-badges",
    component: () => import('../components/admin/Table/UserBadges/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/chatbot-conversations",
    name: "chatbot-conversations",
    route: "chatbot-conversations",
    component: () => import('../components/admin/Table/ChatbotConversations/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/table/upload-image",
    name: "upload-image",
    route: "upload-image",
    component: () => import('../components/admin/Table/UploadImage/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/upload-image/edit/:id",
    name: "upload-image-edit",
    route: "upload-image-edit",
    component: () => import('../components/admin/Table/UploadImage/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/incentive/user-incentive",
    name: "user-incentive-list",
    route: "user-incentive-list",
    component: () => import('../components/admin/Incentive/UserIncentive/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/incentives/incentive-management",
    name: "incentive-management-list",
    route: "incentive-management-list",
    component: () => import('../components/admin/Incentive/IncentiveManagement/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/incentives/incentive-management/create",
    name: "incentive-management-create",
    route: "incentive-management-create",
    component: () => import('../components/admin/Incentive/IncentiveManagement/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/incentives/incentive-management/edit/:id",
    name: "incentive-management-edit",
    route: "incentive-management-edit",
    component: () => import('../components/admin/Incentive/IncentiveManagement/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/incentives/master-incentive-management",
    name: "master-incentive-management-list",
    route: "master-incentive-management-list",
    component: () => import('../components/admin/Incentive/IncentiveManagement/MasterIndex.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/jobseeker-dp-profile/view/:id",
    name: "jobseeker-dp-profile-view",
    route: "jobseeker-dp-profile-view",
    component: () => import('../components/admin/JobseekerAdmin/JobseekerDailyPaidProfileView.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/jobseeker-settings",
    name: "jobseeker-settings",
    route: "jobseeker-settings",
    component: () => import('../components/admin/jobseeker/JobseekerSettings.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/admin/database/broadcast-notification-email",
    name: "broadcast-notification-email-list",
    route: "broadcast-notification-email-list",
    component: () => import('../components/admin/BroadcastNotificationEmail/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/email-template",
    name: "emailtemplate-list",
    route: "emailtemplate-list",
    component: () => import('../components/admin/EmailTemplate/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/email-template/edit/:id",
    name: "emailtemplate-edit",
    route: "emailtemplate-edit",
    component: () => import('../components/admin/EmailTemplate/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/landing-page",
    name: "landingpage-list",
    route: "landingpage-list",
    component: () => import('../components/admin/LandingPage/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/landing-page/create",
    name: "landingpage-add",
    route: "landingpage-add",
    component: () => import('../components/admin/LandingPage/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/landing-page/edit/:id",
    name: "landingpage-edit",
    route: "landingpage-edit",
    component: () => import('../components/admin/LandingPage/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/employer/dashboard",
    name: "employer-dashboard",
    route: "employer-dashboard",
    component: () => import('../components/Employer/EmployerDashboard.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/employer-profile",
    name: "employee-profile",
    route: "employee-profile",
    component: () => import('../components/Employer/empProfile.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/om-supervisor-profile",
    name: "om-supervisor-profile",
    route: "om-supervisor-profile",
    component: () => import('../components/OmSupervisor/OmSupervisorProfile.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/admin/jobseekers",
    name: "jobseekers-list",
    route: "jobseekers-list",
    component: () => import('../components/admin/JobseekerAdmin/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/jobseekers/ft-create",
    name: "jobseekers-ft-create",
    route: "jobseekers-ft-create",
    component: () => import('../components/admin/JobseekerAdmin/FtCreate.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/jobseekers/ft-edit/:id",
    name: "jobseekers-ft-edit",
    route: "jobseekers-ft-edit",
    component: () => import('../components/admin/JobseekerAdmin/FtEdit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/jobseekers/dp-edit/:id",
    name: "jobseekers-dp-edit",
    route: "jobseekers-dp-edit",
    component: () => import('../components/admin/JobseekerAdmin/DpEdit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/jobseekers/dp-create",
    name: "jobseekers-dp-create",
    route: "jobseekers-dp-create",
    component: () => import('../components/admin/JobseekerAdmin/DpCreate.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/employer",
    name: "employer-list",
    route: "employer-list",
    component: () => import('../components/admin/Employer/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/create",
    name: "employer-create",
    route: "employer-create",
    component: () => import('../components/admin/Employer/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/edit/:id",
    name: "employer-edit",
    route: "employer-edit",
    component: () => import('../components/admin/Employer/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/all-jobs/:id",
    name: "employer-all-jobs",
    route: "employer-all-jobs",
    component: () => import('../components/admin/Employer/DailyPaidJobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/audit-jobs/:id/:company_id",
    name: "employer-audit-jobs",
    route: "employer-audit-jobs",
    component: () => import('../components/admin/Employer/AuditJobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/audit-jobs-detail/:id/",
    name: "employer-audit-jobs-detail",
    route: "employer-audit-jobs-detail",
    component: () => import('../components/admin/Employer/AuditJobsDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/fulltime-job-list",
    name: "fulltime-job-list",
    route: "fulltime-job-list",
    component: () => import('../components/admin/FullTimeJob/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/fulltime-emp-job-list/:id",
    name: "fulltime-emp-job-list",
    route: "fulltime-emp-job-list",
    component: () => import('../components/admin/FullTimeJob/EmployerJobList.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin-fulltimejob-viewcandidates/:id",
    name: "fulltimejob-viewcandidates",
    route: "fulltimejob-viewcandidates",
    component: () => import('../components/admin/FullTimeJob/ViewCandidates.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/fulltime-job-fl-profile/view/:id",
    name: "fulltime-job-fl-profile",
    route: "fulltime-job-fl-profile",
    component: () => import('../components/admin/FullTimeJob/JobseekerProfileView.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/fulltime/job-detail/:id",
    name: "fullTimeJobDetail",
    route: "fullTimeJobDetail",
    component: () => import('../components/admin/FullTimeJob/JobDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/fulltime/post-job",
    name: "fullTimePostJob",
    route: "fullTimePostJob",
    component: () => import('../components/admin/FullTimeJob/postJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/fulltime/edit-job/:id",
    name: "fullTimeEditJob",
    route: "fullTimeEditJob",
    component: () => import('../components/admin/FullTimeJob/editJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/fulltime/edit-drafted-job/:id",
    name: "fullTimeEditSavedJob",
    route: "fullTimeEditSavedJob",
    component: () => import('../components/admin/FullTimeJob/editSavedJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/fulltime/repost-job/:id",
    name: "fullTimeRepostJob",
    route: "fullTimeRepostJob",
    component: () => import('../components/admin/FullTimeJob/repostJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/employer-profile/view/:id/:company_id",
    name: "employer-profile-view",
    route: "employer-profile-view",
    component: () => import('../components/admin/Employer/EmployerProfileView.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/educational-qualification",
    name: "educational-qualification-list",
    route: "educational-qualification-list",
    component: () => import('../components/admin/EducationalQualification/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/educational-qualification/create",
    name: "educational-qualification-create",
    route: "educational-qualification-create",
    component: () => import('../components/admin/EducationalQualification/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/educational-qualification/edit/:id",
    name: "educational-qualification-edit",
    route: "educational-qualification-edit",
    component: () => import('../components/admin/EducationalQualification/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/university",
    name: "university-list",
    route: "university-list",
    component: () => import('../components/admin/University/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/university/create",
    name: "university-create",
    route: "university-create",
    component: () => import('../components/admin/University/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/university/edit/:id",
    name: "university-edit",
    route: "university-edit",
    component: () => import('../components/admin/University/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/nric-initial",
    name: "nric-initial-list",
    route: "nric-initial-list",
    component: () => import('../components/admin/NricInitial/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/nric-initial/create",
    name: "nric-initial-create",
    route: "nric-initial-create",
    component: () => import('../components/admin/NricInitial/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/country",
    name: "country-list",
    route: "country-list",
    component: () => import('../components/admin/Country/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/nationality",
    name: "nationality-list",
    route: "nationality-list",
    component: () => import('../components/admin/Nationality/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/field-of-study",
    name: "field-of-study-list",
    route: "field-of-study-list",
    component: () => import('../components/admin/FieldOfStudy/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/field-of-study/create",
    name: "field-of-study-create",
    route: "field-of-study-create",
    component: () => import('../components/admin/FieldOfStudy/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/field-of-study/edit/:id",
    name: "field-of-study-edit",
    route: "field-of-study-edit",
    component: () => import('../components/admin/FieldOfStudy/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/staff",
    name: "staff-list",
    route: "staff-list",
    component: () => import('../components/admin/Staff/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/staff/create",
    name: "staff-create",
    route: "staff-create",
    component: () => import('../components/admin/Staff/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/staff/edit/:id",
    name: "staff-edit",
    route: "staff-edit",
    component: () => import('../components/admin/Staff/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/staff/edit/permission-v1/:id",
    name: "staff-edit-permission-v1",
    route: "staff-edit-permission-v1",
    component: () => import('../components/admin/Staff/EditPermissionV1.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/staff/profile/:id",
    name: "staff-view-profile",
    route: "staff-view-profile",
    component: () => import('../components/admin/Staff/ViewProfile.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/staff/attached-users/:id",
    name: "staff-attached-users",
    route: "staff-attached-users",
    component: () => import('../components/admin/Staff/AttachedUsers.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/transaction",
    name: "transaction-list",
    route: "transaction-list",
    component: () => import('../components/admin/Transaction/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/penalty-management",
    name: "penalty-management-list",
    route: "penalty-management-list",
    component: () => import('../components/admin/PenaltyManagement/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/payout",
    name: "payout-list",
    route: "payout-list",
    component: () => import('../components/admin/Payout/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/topup",
    name: "topup-list",
    route: "topup-list",
    component: () => import('../components/admin/Topup/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/leaderboard",
    name: "admin-leaderboard",
    route: "admin-leaderboard",
    component: () => import('../components/admin/Leaderboard/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/weekly-meeting",
    name: "weekly-meeting",
    route: "weekly-meeting",
    component: () => import('../components/admin/WeeklyMeeting/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/lucky-draw",
    name: "admin-lucky-draw",
    route: "admin-lucky-draw",
    component: () => import('../components/admin/LuckyDraw/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/business-referrals",
    name: "admin-business-referrals",
    route: "admin-business-referrals",
    component: () => import('../components/admin/BusinessReferral/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/sharing-campaign",
    name: "admin-sharing-campaign",
    route: "admin-sharing-campaign",
    component: () => import('../components/admin/SharingCampaign/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/loyalty-program/user-list",
    name: "user-list",
    route: "user-list",
    component: () => import('../components/admin/LoyaltyProgram/UserList/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/payout-view/:id",
    name: "payout-view",
    route: "payout-view",
    component: () => import('../components/admin/Payout/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/broadcast-notification",
    name: "broadcast-notification-list",
    route: "broadcast-notification-list",
    component: () => import('../components/admin/BroadcastNotification/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/broadcast-notification-view/:id",
    name: "broadcast-notification-view",
    route: "broadcast-notification-view",
    component: () => import('../components/admin/BroadcastNotification/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/broadcast-notification-edit/:id",
    name: "broadcast-notification-edit",
    route: "broadcast-notification-edit",
    component: () => import('../components/admin/BroadcastNotification/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/support-ticket-list",
    name: "admin-support-ticket-list",
    route: "admin-support-ticket-list",
    component: () => import('../components/admin/SupportTicket/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/support-ticket-view/:id",
    name: "admin-support-ticket-view",
    route: "admin-support-ticket-view",
    component: () => import('../components/admin/SupportTicket/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/support-message-list",
    name: "admin-support-message-list",
    route: "admin-support-message-list",
    component: () => import('../components/admin/SupportMessage/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/support-message/pending/:id",
    name: "admin-support-message-pending",
    route: "admin-support-message-pending",
    component: () => import('../components/admin/SupportMessage/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/support-message/solved/:id",
    name: "admin-support-message-solved",
    route: "admin-support-message-solved",
    component: () => import('../components/admin/SupportMessage/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/online-training",
    name: "admin-online-training",
    route: "admin-online-training",
    component: () => import('../components/admin/OnlineTraining/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/database/subscribed-email",
    name: "subscribed-email-list",
    route: "subscribed-email-list",
    component: () => import('../components/admin/SubscribedEmail/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/automation-tracker",
    name: "automation-tracker",
    route: "automation-tracker",
    component: () => import('../components/admin/AutomationTracker/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/ota-releases",
    name: "ota-releases-list",
    route: "ota-releases-list",
    component: () => import('../components/admin/OtaReleases/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/bank",
    name: "bank-list",
    route: "bank-list",
    component: () => import('../components/admin/Bank/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/bank/create",
    name: "bank-create",
    route: "bank-create",
    component: () => import('../components/admin/Bank/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/bank/edit/:id",
    name: "bank-edit",
    route: "bank-edit",
    component: () => import('../components/admin/Bank/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/postal-district",
    name: "postal-district-list",
    route: "postal-district-list",
    component: () => import('../components/admin/PostalDistrict/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/postal-district/create",
    name: "postal-district-create",
    route: "postal-district-create",
    component: () => import('../components/admin/PostalDistrict/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/postal-district/edit/:id",
    name: "postal-district-edit",
    route: "postal-district-edit",
    component: () => import('../components/admin/PostalDistrict/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/reward",
    name: "reward-list",
    route: "reward-list",
    component: () => import('../components/admin/Reward/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/reward/create",
    name: "reward-create",
    route: "reward-create",
    component: () => import('../components/admin/Reward/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/reward/edit/:id",
    name: "reward-edit",
    route: "reward-edit",
    component: () => import('../components/admin/Reward/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/service-category",
    name: "service-category-list",
    route: "service-category-list",
    component: () => import('../components/admin/ServiceCategory/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/service-category/create",
    name: "service-category-create",
    route: "service-category-create",
    component: () => import('../components/admin/ServiceCategory/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/service-category/edit/:id",
    name: "service-category-edit",
    route: "service-category-edit",
    component: () => import('../components/admin/ServiceCategory/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/service-category-dp",
    name: "service-category-dp-list",
    route: "service-category-dp-list",
    component: () => import('../components/admin/ServiceCategoryDP/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/service-category-dp/create",
    name: "service-category-dp-create",
    route: "service-category-dp-create",
    component: () => import('../components/admin/ServiceCategoryDP/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/service-category-dp/edit/:id",
    name: "service-category-dp-edit",
    route: "service-category-dp-edit",
    component: () => import('../components/admin/ServiceCategoryDP/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/race",
    name: "race-list",
    route: "race-list",
    component: () => import('../components/admin/Race/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/race/create",
    name: "race-create",
    route: "race-create",
    component: () => import('../components/admin/Race/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/race/edit/:id",
    name: "race-edit",
    route: "race-edit",
    component: () => import('../components/admin/Race/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/position-level",
    name: "position-level-list",
    route: "position-level-list",
    component: () => import('../components/admin/PositionLevel/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/position-level/create",
    name: "position-level-create",
    route: "position-level-create",
    component: () => import('../components/admin/PositionLevel/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/position-level/edit/:id",
    name: "position-level-edit",
    route: "position-level-edit",
    component: () => import('../components/admin/PositionLevel/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/location",
    name: "location-list",
    route: "location-list",
    component: () => import('../components/admin/Location/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/location/create",
    name: "location-create",
    route: "location-create",
    component: () => import('../components/admin/Location/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/location/edit/:id",
    name: "location-edit",
    route: "location-edit",
    component: () => import('../components/admin/Location/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/area",
    name: "area-list",
    route: "area-list",
    component: () => import('../components/admin/Area/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/area/create",
    name: "area-create",
    route: "area-create",
    component: () => import('../components/admin/Area/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/area/edit/:id",
    name: "area-edit",
    route: "area-edit",
    component: () => import('../components/admin/Area/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/certificate",
    name: "certificate-list",
    route: "certificate-list",
    component: () => import('../components/admin/Certificate/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/certificate/create",
    name: "certificate-create",
    route: "certificate-create",
    component: () => import('../components/admin/Certificate/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/certificate/edit/:id",
    name: "certificate-edit",
    route: "certificate-edit",
    component: () => import('../components/admin/Certificate/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/certificate-type",
    name: "certificate-type-list",
    route: "certificate-type-list",
    component: () => import('../components/admin/CertificateType/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/certificate-type/create",
    name: "certificate-type-create",
    route: "certificate-type-create",
    component: () => import('../components/admin/CertificateType/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/certificate-type/edit/:id",
    name: "certificate-type-edit",
    route: "certificate-type-edit",
    component: () => import('../components/admin/CertificateType/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/per-hour-cost",
    name: "per-hour-cost-list",
    route: "per-hour-cost-list",
    component: () => import('../components/admin/PerHourCost/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/employment-status",
    name: "employment-status-list",
    route: "employment-status-list",
    component: () => import('../components/admin/EmploymentStatus/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/employment-status/create",
    name: "employment-status-create",
    route: "employment-status-create",
    component: () => import('../components/admin/EmploymentStatus/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/employment-status/edit/:id",
    name: "employment-status-edit",
    route: "employment-status-edit",
    component: () => import('../components/admin/EmploymentStatus/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/designation",
    name: "designation-list",
    route: "designation-list",
    component: () => import('../components/admin/Designation/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/designation/create",
    name: "designation-create",
    route: "designation-create",
    component: () => import('../components/admin/Designation/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/designation/edit/:id",
    name: "designation-edit",
    route: "designation-edit",
    component: () => import('../components/admin/Designation/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/general-setting",
    name: "general-setting-list",
    route: "general-setting-list",
    component: () => import('../components/admin/GeneralSetting/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/general-setting/edit",
    name: "general-setting-edit",
    route: "general-setting-edit",
    component: () => import('../components/admin/GeneralSetting/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/faq",
    name: "faq-list",
    route: "faq-list",
    component: () => import('../components/admin/Faq/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/faq/create",
    name: "faq-create",
    route: "faq-create",
    component: () => import('../components/admin/Faq/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/faq/edit/:id",
    name: "faq-edit",
    route: "faq-edit",
    component: () => import('../components/admin/Faq/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/training",
    name: "training-list",
    route: "training-list",
    component: () => import('../components/admin/Training/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/training/create",
    name: "training-create",
    route: "training-create",
    component: () => import('../components/admin/Training/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/training/edit/:id",
    name: "training-edit",
    route: "training-edit",
    component: () => import('../components/admin/Training/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/testimonial",
    name: "testimonial-list",
    route: "testimonial-list",
    component: () => import('../components/admin/Testimonial/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/testimonial/create",
    name: "testimonial-create",
    route: "testimonial-create",
    component: () => import('../components/admin/Testimonial/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/testimonial/edit/:id",
    name: "testimonial-edit",
    route: "testimonial-edit",
    component: () => import('../components/admin/Testimonial/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/ticket-type",
    name: "ticket-type-list",
    route: "ticket-type-list",
    component: () => import('../components/admin/TicketType/index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/ticket-type/create",
    name: "ticket-type-create",
    route: "ticket-type-create",
    component: () => import('../components/admin/TicketType/create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/ticket-type/edit/:id",
    name: "ticket-type-edit",
    route: "ticket-type-edit",
    component: () => import('../components/admin/TicketType/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/static-page",
    name: "static-page-list",
    route: "static-page-list",
    component: () => import('../components/admin/StaticPage/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/static-page/edit/:id",
    name: "static-page-edit",
    route: "static-page-edit",
    component: () => import('../components/admin/StaticPage/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/database/service-agreement",
    name: "service-agreement",
    route: "service-agreement",
    component: () => import('../components/admin/ServiceAgreement/index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/service-agreement/edit",
    name: "service-agreement-edit",
    route: "service-agreement-edit",
    component: () => import('../components/admin/ServiceAgreement/edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/process-description",
    name: "process-description-list",
    route: "process-description-list",
    component: () => import('../components/admin/ProcessDescription/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/process-description/edit/:id",
    name: "process-description-edit",
    route: "process-description-edit",
    component: () => import('../components/admin/ProcessDescription/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/app-content",
    name: "app-content-list",
    route: "app-content-list",
    component: () => import('../components/admin/AppContent/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/app-content/edit/:id",
    name: "app-content-edit",
    route: "app-content-edit",
    component: () => import('../components/admin/AppContent/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/elcy-greeting-messages",
    name: "elcy-greeting-messages-list",
    route: "elcy-greeting-messages-list",
    component: () => import('../components/admin/ELCYGreetingMessages/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/elcy-greeting-messages/create",
    name: "elcy-greeting-messages-create",
    route: "elcy-greeting-messages-create",
    component: () => import('../components/admin/ELCYGreetingMessages/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/elcy-greeting-messages/edit/:messageId",
    name: "elcy-greeting-messages-edit",
    route: "elcy-greeting-messages-edit",
    component: () => import('../components/admin/ELCYGreetingMessages/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/blog",
    name: "blog-list",
    route: "blog-list",
    component: () => import('../components/admin/Blog/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/blog/create",
    name: "blog-create",
    route: "blog-create",
    component: () => import('../components/admin/Blog/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/blog/edit/:id",
    name: "blog-edit",
    route: "blog-edit",
    component: () => import('../components/admin/Blog/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/website-content/past-winner",
    name: "past-winner-list",
    route: "past-winner-list",
    component: () => import('../components/admin/PastWinner/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/past-winner/create",
    name: "past-winner-create",
    route: "past-winner-create",
    component: () => import('../components/admin/PastWinner/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/past-winner/edit/:id",
    name: "past-winner-edit",
    route: "past-winner-edit",
    component: () => import('../components/admin/PastWinner/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/jobseeker-content",
    name: "jobseeker-content-list",
    route: "jobseeker-content-list",
    component: () => import('../components/admin/JobseekerContent/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/jobseeker-content/edit/:id",
    name: "jobseeker-content-edit",
    route: "jobseeker-content-edit",
    component: () => import('../components/admin/JobseekerContent/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/banner",
    name: "banner-list",
    route: "banner-list",
    component: () => import('../components/admin/Banner/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/banner/create",
    name: "banner-create",
    route: "banner-create",
    component: () => import('../components/admin/Banner/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/banner/edit/:id",
    name: "banner-edit",
    route: "banner-edit",
    component: () => import('../components/admin/Banner/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/app-banner",
    name: "app-banner-list",
    route: "app-banner-list",
    component: () => import('../components/admin/AppBanner/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/app-banner/create",
    name: "app-banner-create",
    route: "app-banner-create",
    component: () => import('../components/admin/AppBanner/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/app-banner/edit/:id",
    name: "app-banner-edit",
    route: "app-banner-edit",
    component: () => import('../components/admin/AppBanner/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/app-banner/terms/:id",
    name: "app-banner-tnc",
    route: "app-banner-tnc",
    component: () => import('../components/admin/ViewTnc.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/partner",
    name: "partner-list",
    route: "partner-list",
    component: () => import('../components/admin/Partner/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/partner/create",
    name: "partner-create",
    route: "partner-create",
    component: () => import('../components/admin/Partner/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/partner/edit/:id",
    name: "partner-edit",
    route: "partner-edit",
    component: () => import('../components/admin/Partner/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/marketing-popup",
    name: "marketing-popup-list",
    route: "marketing-popup-list",
    component: () => import('../components/admin/MarketingPopup/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/marketing-popup/create",
    name: "marketing-popup-create",
    route: "marketing-popup-create",
    component: () => import('../components/admin/MarketingPopup/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/marketing-popup/edit/:id",
    name: "marketing-popup-edit",
    route: "marketing-popup-edit",
    component: () => import('../components/admin/MarketingPopup/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/marketing-popup/terms/:id",
    name: "marketing-popup-tnc",
    route: "marketing-popup-tnc",
    component: () => import('../components/admin/ViewTnc.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/marketing-popup-employer",
    name: "marketing-popup-employer-list",
    route: "marketing-popup-employer-list",
    component: () => import('../components/admin/MarketingPopupEmployer/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/marketing-popup-employer/create",
    name: "marketing-popup-employer-create",
    route: "marketing-popup-employer-create",
    component: () => import('../components/admin/MarketingPopupEmployer/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/marketing-popup-employer/edit/:id",
    name: "marketing-popup-employer-edit",
    route: "marketing-popup-employer-edit",
    component: () => import('../components/admin/MarketingPopupEmployer/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/marketing-popup-employer/terms/:id",
    name: "marketing-popup-employer-tnc",
    route: "marketing-popup-employer-tnc",
    component: () => import('../components/admin/ViewTnc.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/job-poster",
    name: "job-poster-list",
    route: "job-poster-list",
    component: () => import('../components/admin/JobPoster/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/job-poster/create",
    name: "job-poster-create",
    route: "job-poster-create",
    component: () => import('../components/admin/JobPoster/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/job-poster/edit/:id",
    name: "job-poster-edit",
    route: "job-poster-edit",
    component: () => import('../components/admin/JobPoster/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/permanent-pt-job",
    name: "permanent-pt-job-list",
    route: "permanent-pt-job-list",
    component: () => import('../components/admin/PermanentPTJob/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/permanent-pt-job/create",
    name: "permanent-pt-job-create",
    route: "permanent-pt-job-create",
    component: () => import('../components/admin/PermanentPTJob/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/permanent-pt-job/edit/:id",
    name: "permanent-pt-job-edit",
    route: "permanent-pt-job-edit",
    component: () => import('../components/admin/PermanentPTJob/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/gig-list",
    name: "gig-list",
    route: "gig-list",
    component: () => import('../components/admin/Gig/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/gig-missions/detail/:id",
    name: "admin-gig-detail",
    component: () => import('../components/admin/Gig/GigDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/gig-missions/offers/:id",
    name: "admin-gig-offers",
    component: () => import('../components/admin/Gig/ViewOffers.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/marketing/report",
    name: "marketing-report",
    component: () => import('../components/admin/Marketing/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/gig-missions/edit/:id",
    name: "admin-gig-edit",
    component: () => import('../components/admin/Gig/EditGig.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/gig-missions/duplicate/:id",
    name: "admin-gig-duplicate",
    component: () => import('../components/admin/Gig/DuplicateGig.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/gig-missions/audit-log/:id",
    name: "admin-gig-audit-log",
    component: () => import('../components/admin/Gig/GigAuditLog.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  // { path: "/v2/admin/database/gigplace", name: "gigplace-list", route: "gigplace-list", component: GigplaceList, meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" } }, // gigplace disabled
  // { path: "/v2/admin/database/gigplace/edit/:id", name: "gigplace-edit", route: "gigplace-edit", component: GigplaceEdit, meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" } },
  {
    path: "/v2/admin/database/promotion",
    name: "promotion-list",
    route: "promotion-list",
    component: () => import('../components/admin/Promotion/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/promotion/create",
    name: "promotion-create",
    route: "promotion-create",
    component: () => import('../components/admin/Promotion/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/promotion/edit/:id",
    name: "promotion-edit",
    route: "promotion-edit",
    component: () => import('../components/admin/Promotion/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/campaign",
    name: "campaign-list",
    route: "campaign-list",
    component: () => import('../components/admin/Campaign/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/campaign/create",
    name: "campaign-create",
    route: "campaign-create",
    component: () => import('../components/admin/Campaign/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/campaign/edit/:id",
    name: "campaign-edit",
    route: "campaign-edit",
    component: () => import('../components/admin/Campaign/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/website-content/campaign/terms/:id",
    name: "campaign-tnc",
    route: "campaign-tnc",
    component: () => import('../components/admin/ViewTnc.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/whatsapp-template",
    name: "whatsapp-template-list",
    route: "whatsapp-template-list",
    component: () => import('../components/admin/WhatsAppTemplate/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/whatsapp-template/create",
    name: "whatsapp-template-create",
    route: "whatsapp-template-create",
    component: () => import('../components/admin/WhatsAppTemplate/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/whatsapp-template/edit/:id",
    name: "whatsapp-template-edit",
    route: "whatsapp-template-edit",
    component: () => import('../components/admin/WhatsAppTemplate/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/gallery",
    name: "gallery-list",
    route: "gallery-list",
    component: () => import('../components/admin/Gallery/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/penalty-remark",
    name: "penalty-remark-list",
    route: "penalty-remark-list",
    component: () => import('../components/admin/PenaltyRemark/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/el-coin",
    name: "el-coin-list",
    route: "el-coin-list",
    component: () => import('../components/admin/ELCoin/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/el-coin/create",
    name: "el-coin-create",
    route: "el-coin-create",
    component: () => import('../components/admin/ELCoin/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/el-coin/edit/:id",
    name: "el-coin-edit",
    route: "el-coin-edit",
    component: () => import('../components/admin/ELCoin/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/el-membership",
    name: "el-membership-list",
    route: "el-membership-list",
    component: () => import('../components/admin/ELMembership/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/el-membership/edit/:id",
    name: "el-membership-edit",
    route: "el-membership-edit",
    component: () => import('../components/admin/ELMembership/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/referral-history",
    name: "referral-history-list",
    route: "referral-history-list",
    component: () => import('../components/admin/Referal/index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/user-logs",
    name: "user-logs",
    route: "user-logs",
    component: () => import('../components/admin/Logs/index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/badge",
    name: "badge-list",
    route: "badge-list",
    component: () => import('../components/admin/BadgeMaster/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/badge/create",
    name: "badge-create",
    route: "badge-create",
    component: () => import('../components/admin/BadgeMaster/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/badge/edit/:id",
    name: "badge-edit",
    route: "badge-edit",
    component: () => import('../components/admin/BadgeMaster/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/holidays",
    name: "holidays-list",
    route: "holidays-list",
    component: () => import('../components/admin/Holidays/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/holidays/create",
    name: "holiday-create",
    route: "holiday-create",
    component: () => import('../components/admin/Holidays/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/holidays/edit/:id",
    name: "holiday-edit",
    route: "holiday-edit",
    component: () => import('../components/admin/Holidays/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/incentive/:id",
    name: "incentive",
    route: "incentive",
    component: () => import('../components/admin/JobseekerAdmin/incentive.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/jobseeker/dp-managejobs/:id",
    name: "jobseekerDPManagejobsAdmin",
    route: "jobseekerDPManagejobsAdmin",
    component: () => import('../components/admin/JobseekerAdmin/dpManagejobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/jobseeker/ptuser-jobs/:id/:schedule?",
    name: "jobseekerDPjobsAdmin",
    route: "jobseekerDPjobsAdmin",
    component: () => import('../components/admin/jobseeker/dpJobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/settings",
    name: "employer-setting",
    route: "employer-setting",
    component: () => import('../components/Employer/EmployerSetting.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/change-password",
    name: "employer-change-password",
    route: "employer-change-password",
    component: () => import('../components/Employer/ChangePassword.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/employer-ratings-reviews",
    name: "employer-ratings-reviews",
    route: "employer-ratings-reviews",
    component: () => import('../components/Employer/RatingsReviews.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/employer-service-report",
    name: "employer-service-report",
    route: "employer-service-report",
    component: () => import('../components/Employer/ServiceReport.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/employer-invoice",
    name: "employer-invoice",
    route: "employer-invoice",
    component: () => import('../components/Employer/Invoice.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/employer-ticket-list",
    name: "employer-ticket-list",
    route: "employer-ticket-list",
    component: () => import('../components/Employer/Ticket/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/employer-ticket-create",
    name: "employer-ticket-create",
    route: "employer-ticket-create",
    component: () => import('../components/Employer/Ticket/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/employer-ticket-view/:id",
    name: "employer-ticket-view",
    route: "employer-ticket-view",
    component: () => import('../components/Employer/Ticket/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/jobseeker/jobseeker-ticket-list",
    name: "jobseeker-ticket-list",
    route: "jobseeker-ticket-list",
    component: () => import('../components/Jobseeker/Ticket/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/jobseeker-ticket-create",
    name: "jobseeker-ticket-create",
    route: "jobseeker-ticket-create",
    component: () => import('../components/Jobseeker/Ticket/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/jobseeker-ticket-view/:id",
    name: "jobseeker-ticket-view",
    route: "jobseeker-ticket-view",
    component: () => import('../components/Jobseeker/Ticket/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/change-password",
    name: "jobseeker-change-password",
    route: "jobseeker-change-password",
    component: () => import('../components/Jobseeker/ChangePassword.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/deactivate-account",
    name: "jobseeker-deactivate-account",
    route: "jobseeker-deactivate-account",
    component: () => import('../components/Jobseeker/DeactivateAccount.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/employer/post-job",
    name: "postJob",
    route: "postJob",
    component: () => import('../components/Employer/postJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/edit-job/:id",
    name: "editJob",
    route: "editJob",
    component: () => import('../components/Employer/editJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/edit-drafted-job/:id",
    name: "editSavedJob",
    route: "editSavedJob",
    component: () => import('../components/Employer/editSavedJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/repost-job/:id",
    name: "repostJob",
    route: "repostJob",
    component: () => import('../components/Employer/repostJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/repost-job-daily/:id",
    name: "repostJobDaily",
    route: "repostJobDaily",
    component: () => import('../components/Employer/DailyPaid/repost.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/jobseeker/joblist",
    name: "jobList",
    route: "jobList",
    component: () => import('../components/admin/jobseeker/jobListing.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/jobseeker/daily-joblist/",
    name: "dailyjobList",
    route: "dailyjobList",
    component: () => import('../components/admin/jobseeker/dailyjobListing.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/jobseeker/gig-missions",
    name: "gig-missions-list",
    route: "gig-missions-list",
    component: () => import('../components/Jobseeker/GigMissions/GigMissionsList.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/gig-missions/create",
    name: "create-gig-mission",
    route: "create-gig-mission",
    component: () => import('../components/Jobseeker/GigMissions/CreateGigMission.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/gig-missions/my-tasks",
    name: "my-posted-gig-missions",
    route: "my-posted-gig-missions",
    component: () => import('../components/Jobseeker/GigMissions/MyPostedGigMissions.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/gig-missions/my-offers",
    name: "my-gig-offers",
    route: "my-gig-offers",
    component: () => import('../components/Jobseeker/GigMissions/MyGigOffers.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/gig-missions/detail/:id",
    name: "gig-mission-detail",
    route: "gig-mission-detail",
    component: () => import('../components/Jobseeker/GigMissions/GigMissionDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/gig-missions/chat/:gig_id/:offer_id",
    name: "gig-mission-chat",
    route: "gig-mission-chat",
    component: () => import('../components/Jobseeker/GigMissions/GigMissionChat.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/gig-missions/submit/:gigId/:offerId",
    name: "gig-submit-deliverables",
    route: "gig-submit-deliverables",
    component: () => import('../components/Jobseeker/GigMissions/GigSubmitDeliverables.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/jobseeker/emp-daily-joblist/:id",
    name: "empDailyjobList",
    route: "empDailyjobList",
    component: () => import('../components/admin/jobseeker/empDailyjobList.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/emp-joblist/:id",
    name: "employerJobList",
    route: "employerJobList",
    component: () => import('../components/admin/jobseeker/EmployerJobList.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/ft-jobdetail/:id",
    name: "jobDetail",
    route: "jobDetail",
    component: () => import('../components/admin/jobseeker/jobDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/dp-jobdetail/:id",
    name: "dailyJobDetail",
    route: "dailyJobDetail",
    component: () => import('../components/admin/jobseeker/dailyJobDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/manage-candidates/:id",
    name: "manage-candidates",
    route: "manage-candidates",
    component: () => import('../components/Employer/ManageCandidates.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/manage-all-jobs-candidates",
    name: "manage-all-jobs-candidates",
    route: "manage-all-jobs-candidates",
    component: () => import('../components/Employer/ManageAllJobsCandidates.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/manage-jobs",
    name: "manage-jobs",
    route: "manage-jobs",
    component: () => import('../components/Employer/ManageJobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/drafted-jobs",
    name: "saved-jobs",
    route: "saved-jobs",
    component: () => import('../components/Employer/SavedJobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/jobseeker/jobseeker-bookmark-job-list",
    name: "jobseeker-bookmark-job-list",
    route: "jobseeker-bookmark-job-list",
    component: () => import('../components/Jobseeker/BookmarkJob/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/jobseeker-bookmark-emp-list",
    name: "jobseeker-bookmark-emp-list",
    route: "jobseeker-bookmark-emp-list",
    component: () => import('../components/Jobseeker/BookmarkEmployer/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/employer/employer-bookmark-jobseeker-list",
    name: "employer-bookmark-jobseeker-list",
    route: "employer-bookmark-jobseeker-list",
    component: () => import('../components/Employer/BookmarkJobseeker/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/jobseeker/applied-jobs-list",
    name: "applied-jobs-list",
    route: "applied-jobs-list",
    component: () => import('../components/Jobseeker/AppliedJobs/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/payment",
    name: "paymentst",
    component: () => import('../components/admin/jobseeker/make-payment.vue'),
    meta: { requiresAuth: true, hideForAuth: false },
  },
  {
    path: "/v2/employer/ft-jobdetail/:id",
    name: "employerJobDetail",
    route: "employerJobDetail",
    component: () => import('../components/Employer/JobDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/elcoins",
    name: "elcoins",
    component: () => import('../components/ElCoins/coinPurchase.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/user-coins",
    name: "userCoins",
    component: () => import('../components/Employer/coinsDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/profile-daily-paid-detail",
    name: "empDailyPaidProfile",
    component: () => import('../components/Employer/empDailyPaidProfile.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/billing-address-list",
    name: "billingAddress",
    component: () => import('../components/Employer/billing_address.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/billing-address-add",
    name: "addbillingAddress",
    component: () => import('../components/Employer/add-billing-address.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/approve-job",
    name: "approveJob",
    component: () => import('../components/Employer/approveJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/admin/approve-job",
    name: "approveJobAdmin",
    component: () => import('../components/Employer/approveJob.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/billing-address-add/:id/:company_id",
    name: "addbillingAddressAdmin",
    component: () => import('../components/admin/Employer/AddBillingAddress.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/billing-address-edit/:id/:user_id/:company_id",
    name: "editbillingAddressAdmin",
    component: () => import('../components/admin/Employer/EditbillingAddress.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/employer/billing-address-edit/:id",
    name: "editbillingAddress",
    component: () => import('../components/Employer/edit-billing-address.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/card-list",
    name: "cardList",
    component: () => import('../components/Employer/card-list.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/card-add",
    name: "addCard",
    component: () => import('../components/Employer/add-card.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/transactions",
    name: "transactions",
    component: () => import('../components/Employer/transaction.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/job-transactions",
    name: "jobTransactions",
    component: () => import('../components/Employer/jobTransactions.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/topup",
    name: "emp-topup",
    route: "emp-topup",
    component: () => import('../components/Employer/TopUp.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/rewards",
    name: "emp-reward-list",
    route: "emp-reward-list",
    component: () => import('../components/Employer/Reward/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/reward-detail/:id",
    name: "emp-reward-view",
    route: "emp-reward-view",
    component: () => import('../components/Employer/Reward/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/reward-enquiry",
    name: "emp-reward-enquiry",
    route: "emp-reward-enquiry",
    component: () => import('../components/Employer/Reward/Enquiry.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/manage-user",
    name: "empManageUserList",
    route: "empManageUserList",
    component: () => import('../components/Employer/ManageUser/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/manage-user/create",
    name: "empManageUserCreate",
    route: "empManageUserCreate",
    component: () => import('../components/Employer/ManageUser/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/manage-user/edit/:id",
    name: "empManageUserEdit",
    route: "empManageUserEdit",
    component: () => import('../components/Employer/ManageUser/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/manage-user/view/:id",
    name: "emp-manage-user-view",
    route: "emp-manage-user-view",
    component: () => import('../components/Employer/ManageUser/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/candidate-search/:id",
    name: "candidateSearch",
    route: "candidateSearch",
    component: () => import('../components/Employer/candidate-search.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/jobseeker/payment",
    name: "jobseekerPayment",
    component: () => import('../components/Jobseeker/ELCoin//make-payment.vue'),
    meta: { requiresAuth: true, hideForAuth: false },
  },
  {
    path: "/v2/jobseeker/elcoins",
    name: "jobseekerElcoins",
    component: () => import('../components/Jobseeker/ELCoin//coinPurchase.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/jobseeker/user-coins",
    name: "jobseekerUserCoins",
    component: () => import('../components/Jobseeker/ELCoin/coinsDetail.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "jobseeker/billing-address-list",
    name: "jobseekerBillingAddress",
    component: () => import('../components/Jobseeker/ManageBillingAddress/billing_address.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/billing-address-add",
    name: "jobseekerAddbillingAddress",
    component: () => import('../components/Jobseeker/ManageBillingAddress/add-billing-address.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/card-list",
    name: "jobseekerCardList",
    component: () => import('../components/Jobseeker/ManageCard/card-list.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/card-add",
    name: "jobseekerAddCard",
    component: () => import('../components/Jobseeker/ManageCard/add-card.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/transactions",
    name: "jobseekerTransactions",
    component: () => import('../components/Jobseeker/Transaction/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/employer/jobseeker-profile/view/:id",
    name: "employer-jobseeker-profile-view",
    route: "employer-jobseeker-profile-view",
    component: () => import('../components/Employer/EmployerJobseekerProfileView.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/employer/jobseeker-dp-profile/view/:id",
    name: "employer-jobseeker-dp-profile-view",
    route: "employer-jobseeker-dp-profile-view",
    component: () => import('../components/Employer/EmployerJobseekerDPProfileView.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/jobseeker/employer-profile/view/:id",
    name: "jobseeker-employer-profile-view",
    route: "jobseeker-employer-profile-view",
    component: () => import('../components/Jobseeker/JobseekerEmployerProfileView.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/employer-dp-profile/view/:id",
    name: "jobseeker-employer-dp-profile-view",
    route: "jobseeker-employer-dp-profile-view",
    component: () => import('../components/Jobseeker/JobseekerEmployerDPProfileView.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/jobseeker/daily-job-profile",
    name: "jobseeker-daily-job-profile",
    route: "jobseeker-daily-job-profile",
    component: () => import('../components/admin/jobseeker/dailyjobsprofile.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/jobseeker/manage-certificate",
    name: "manage-certificate",
    route: "manage-certificate",
    component: () => import('../components/admin/jobseeker/managecertificate.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },

  {
    path: "/v2/jobseeker/add-certificate/:id/:cert_id",
    name: "add-certificate",
    route: "add-certificate",
    component: () => import('../components/admin/jobseeker/addCertificates.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },
  {
    path: "/v2/jobseeker/edit-certificate/:id/:cert_id/:edit_id",
    name: "edit-certificate",
    route: "edit-certificate",
    component: () => import('../components/admin/jobseeker/editCertificates.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "jobseeker" },
  },


  {
    path: "/v2/employer/dp-job-post",
    name: "DailyJobPost",
    route: "DailyJobPost",
    component: () => import('../components/Employer/DailyPaid/postjobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/admin/dp-job-post",
    name: "DailyJobPostAdmin",
    route: "DailyJobPostAdmin",
    component: () => import('../components/admin/ManageDpJobs/postjobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/employer/dp-job-edit/:id",
    name: "DailyJobEdit",
    route: "DailyJobEdit",
    component: () => import('../components/Employer/DailyPaid/editjobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },
  {
    path: "/v2/employer/dp-job-manage",
    name: "DailyJobManage",
    route: "DailyJobManage",
    component: () => import('../components/Employer/DailyPaid/manageJobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "employer" },
  },

  {
    path: "/v2/admin/emp-transaction/:id/:company_id",
    name: "EmpTransactionAdmin",
    route: "EmpTransactionAdmin",
    component: () => import('../components/admin/Employer/EmpTransaction.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/emp-manage-user/:id",
    name: "EmpManageUserAdmin",
    route: "EmpManageUserAdmin",
    component: () => import('../components/admin/Employer/ManageUser.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/invoices-list",
    name: "EmpInvoices",
    route: "EmpInvoices",
    component: () => import('../components/admin/BillsAndReport/EmployerInvoices.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/invoice-log/:id/:type",
    name: "EmpInvoiceLog",
    route: "EmpInvoiceLog",
    component: () => import('../components/admin/BillsAndReport/EmployerInvoiceLog.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/invoice-adjustments/:id/:type",
    name: "EmpInvoiceAdjustments",
    route: "EmpInvoiceAdjustments",
    component: () => import('../components/admin/BillsAndReport/EmployerInvoiceAdjustments.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/revenue-report",
    name: "RevenueReport",
    route: "RevenueReport",
    component: () => import('../components/admin/BillsAndReport/RevenueReport.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/service-report",
    name: "ServiceReport",
    route: "ServiceReport",
    component: () => import('../components/admin/BillsAndReport/EmployerServiceReport.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/balance-summary",
    name: "BalanceSummary",
    route: "BalanceSummary",
    component: () => import('../components/admin/BillsAndReport/BalanceSummary.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/ft-invoice",
    name: "FTInvoice",
    route: "FTInvoice",
    component: () => import('../components/admin/BillsAndReport/FTInvoice.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/system-audit/invoice-generated",
    name: "InvoiceGenerated",
    route: "InvoiceGenerated",
    component: () => import('../components/admin/SystemAudit/InvoiceGenerated.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/system-audit/payout-reconciliation",
    name: "PayoutReconciliation",
    route: "PayoutReconciliation",
    component: () => import('../components/admin/SystemAudit/PayoutReconciliation.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/system-audit/payslip-generated",
    name: "PayslipGenerated",
    route: "PayslipGenerated",
    component: () => import('../components/admin/SystemAudit/PayslipGenerated.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/system-audit/platform-fee",
    name: "PlatformFeeAudit",
    route: "PlatformFeeAudit",
    component: () => import('../components/admin/SystemAudit/PlatformFeeAudit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/emp-balance",
    name: "EmpBalance",
    route: "EmpBalance",
    component: () => import('../components/admin/Employer/emBalance.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/emp-cashback-report",
    name: "EmpCashbackReport",
    route: "EmpCashbackReport",
    component: () => import('../components/admin/Employer/emCashbackReport.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/campaign-bonus",
    name: "CampaignBonus",
    route: "CampaignBonus",
    component: () => import('../components/admin/jobseeker/CampaignBonus.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/pay-incentive",
    name: "PayIncentive",
    route: "PayIncentive",
    component: () => import('../components/admin/BillsAndReport/PayIncentive.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/users-bonus-list",
    name: "BonusUsers",
    route: "BonusUsers",
    component: () => import('../components/admin/BillsAndReport/BonusUsers.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/credit-note",
    name: "CreditNote",
    route: "CreditNote",
    component: () => import('../components/admin/BillsAndReport/CreditNote.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/fl-timesheet",
    name: "FLTimesheet",
    route: "FLTimesheet",
    component: () => import('../components/admin/BillsAndReport/FLTimesheet.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/fl-balance",
    name: "FLBalance",
    route: "FLBalance",
    component: () => import('../components/admin/BillsAndReport/FLBalance.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/fl-payslip",
    name: "FLPayslip",
    route: "FLPayslip",
    component: () => import('../components/admin/BillsAndReport/FLPayslip.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/fl-payslip-logs/:user_id/:payslip_id/:date",
    name: "FLPayslipLogs",
    route: "FLPayslipLogs",
    component: () => import('../components/admin/BillsAndReport/FLPayslipLogs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/bills-and-reports/emp-service-agreement",
    name: "emp-service-agreement-list",
    route: "emp-service-agreement-list",
    component: () => import('../components/admin/Table/EmpServiceAgreement/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/emp-billing-address/:id/:company_id",
    name: "BillingAddress",
    route: "BillingAddress",
    component: () => import('../components/admin/Employer/BillingAddress.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/emp-gallery-admin/:id/:company_id",
    name: "emp-gallery-admin",
    route: "emp-gallery-admin",
    component: () => import('../components/admin/Employer/Gallery.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/emp-log/:id/:company_id",
    name: "emp-log-admin",
    route: "emp-log-admin",
    component: () => import('../components/admin/Employer/empLog.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/emp-manage-user-view/:id",
    name: "EmpManageUserViewAdmin",
    route: "EmpManageUserViewAdmin",
    component: () => import('../components/admin/Employer/ViewUserProfile.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/emp-manage-user-edit/:id/:company_id",
    name: "EmpManageUserEditAdmin",
    route: "EmpManageUserEditAdmin",
    component: () => import('../components/admin/Employer/EditUser.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },

  {
    path: "/v2/admin/emp-manage-user-create/:id",
    name: "empManageUserCreateAdmin",
    route: "empManageUserCreateAdmin",
    component: () => import('../components/admin/Employer/CreateUser.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/qr-code",
    name: "qr-code-list",
    route: "qr-code-list",
    component: () => import('../components/admin/QRCode/index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/qr-edit/:id",
    name: "qr-code-edit",
    route: "qr-code-edit",
    component: () => import('../components/admin/QRCode/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/employer/checkout",
    component: () => import('../components/ElCoins/checkout.vue'),
    meta: {
      title: "Payment",
      showFor: "employer",
    },
  },
  {
    path: "/return",
    component: () => import('../components/ElCoins/Srreturn.vue'),
    meta: { title: "Return" },
  },
  {
    path: "/v2/admin/company-department/:id/:company_id",
    name: "companyDepartments",
    route: "companyDepartments",
    component: () => import('../components/admin/Departments/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/company-department/:id/:company_id",
    name: "addCompanyDepartmentAdmin",
    component: () => import('../components/admin/Departments/Add.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/company-department/:id/:user_id/:company_id",
    name: "editCompanyDepartmentAdmin",
    component: () => import('../components/admin/Departments/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  // {
  //   path: '/v2/employer/company-departments',
  //   name: 'companyDepartments',
  //   component: companyDepartments,
  //   meta: { requiresAuth: true, hideForAuth:false , showFor:'employer' }
  // },
  // {
  //   path: '/v2/employer/add-company-department',
  //   name: 'addCompanyDepartment',
  //   component: addCompanyDepartment,
  //   meta: { requiresAuth: true, hideForAuth:false  , showFor:'employer'}
  // },
  // {
  //   path: '/v2/employer/edit-company-department/:id',
  //   name: 'editCompanyDepartment',
  //   component: editCompanyDepartment,
  //   meta: { requiresAuth: true, hideForAuth:false  , showFor:'employer'}
  // },

  {
    path: "/v2/admin/database/transaction-sub-types",
    name: "TransactionSubTypes",
    route: "TransactionSubTypes",
    component: () => import('../components/admin/TransactionSubTypes/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/transaction-sub-types/create",
    name: "TransactionSubTypeCreate",
    route: "TransactionSubTypeCreate",
    component: () => import('../components/admin/TransactionSubTypes/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/transaction-sub-types/edit/:id",
    name: "TransactionSubTypeEdit",
    route: "TransactionSubTypeEdit",
    component: () => import('../components/admin/TransactionSubTypes/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/billing-types",
    name: "BillingTypes",
    route: "BillingTypes",
    component: () => import('../components/admin/BillingTypes/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/billing-types/create",
    name: "BillingTypeCreate",
    route: "BillingTypeCreate",
    component: () => import('../components/admin/BillingTypes/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/billing-types/edit/:id",
    name: "BillingTypeEdit",
    route: "BillingTypeEdit",
    component: () => import('../components/admin/BillingTypes/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/medical-history",
    name: "medical-history-list",
    route: "medical-history-list",
    component: () => import('../components/admin/MedicalHistory/index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/medical-history-create",
    name: "medical-history-create",
    route: "medical-history-create",
    component: () => import('../components/admin/MedicalHistory/create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/dp-jobs/dp-jobs-post",
    name: "dp-jobs-post",
    route: "dp-jobs-post",
    component: () => import('../components/admin/ManageDpJobs/postjobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/dp-jobs",
    name: "dp-jobs",
    route: "dp-jobs",
    component: () => import('../components/admin/ManageDpJobs/manageJobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/dp-jobs/dp-jobs-multiple",
    name: "dp-jobs-multiple",
    route: "dp-jobs-multiple",
    component: () => import('../components/admin/ManageDpJobs/manageMultiple.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/dp-jobs/dp-jobs-repost",
    name: "dp-jobs-repost",
    route: "dp-jobs-repost",
    component: () => import('../components/admin/ManageDpJobs/repost.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/dp-jobs/dp-jobs-edit/:id",
    name: "dp-jobs-edit",
    route: "dp-jobs-edit",
    component: () => import('../components/admin/ManageDpJobs/editjobs.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/company-branch/:company_id",
    name: "CompanyBranches",
    route: "CompanyBranches",
    component: () => import('../components/admin/Branch/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/company-branch/:company_id",
    name: "CompanyAddBranch",
    component: () => import('../components/admin/Branch/Add.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/employer/company-branch/:id/:company_id",
    name: "CompanyEditBranch",
    component: () => import('../components/admin/Branch/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/view-audit-job/:id",
    name: "view-audit-job",
    route: "view-audit-job",
    component: () => import('../components/admin/AuditJobLogs/View.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/add-job-expense/NDA0Mj=",
    name: "add-job-expense",
    route: "add-job-expense",
    component: () => import('../components/admin/JobExpense/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/pass",
    name: "pass-list",
    route: "pass-list",
    component: () => import('../components/admin/Pass/Index.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/pass/create",
    name: "pass-create",
    route: "pass-create",
    component: () => import('../components/admin/Pass/Create.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/pass/edit/:id",
    name: "pass-edit",
    route: "pass-edit",
    component: () => import('../components/admin/Pass/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/database/pass/edit/:id",
    name: "pass-edit",
    route: "pass-edit",
    component: () => import('../components/admin/Pass/Edit.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/gig-missions/offers/chat-list/:id",
    name: "gig-chat-list",
    route: "gig-chat-list",
    component: () => import('../views/Chat/ChatList.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
  {
    path: "/v2/admin/gig-missions/offers/chat-screen/:chatId",
    name: "gig-chat-screen",
    route: "gig-chat-screen",
    component: () => import('../views/Chat/ChatListScreen.vue'),
    meta: { requiresAuth: true, hideForAuth: false, showFor: "admin" },
  },
];
